import {deleteCookie, getCookie, setCookie} from "./cookies";

export default class Account {
  constructor() {
    if (!document.body.classList.contains('account')) {
      return;
    }

    this.setOffset();
    this.updateWindow();
    this.menuOverlay();
  }

  // Calculate the remaining amount of Pixels (outside the container)
  setOffset(resizing = false) {
    const container = document.getElementById('account-container');

    if (!container) {
      return;
    }

    // Speedup data by sessionStorage
    let offset = 0;
    if (!resizing && sessionStorage.getItem("account-offset")) {
      offset = sessionStorage.getItem("account-offset");
    } else {
      let containerWidth = container.offsetWidth || container.clientWidth,
        windowWidth = window.innerWidth || document.documentElement.clientWidth || document.body.clientWidth;

      offset = windowWidth - containerWidth;
      sessionStorage.setItem('account-offset', offset);
    }

    // Set CSS variables to the element
    container.style.setProperty('--account-offset', (offset) / 2 + "px");
    container.style.setProperty('--account-offset-negative', '-' + (offset) / 2 + "px");
  }

  // Update window events
  updateWindow() {
    let self = this; // Tried with this instead of self in eventListeners.. didn't work somehow..

    window.addEventListener('resize', (e) => {
      self.setOffset(true);
    });
    window.addEventListener('orientationchange', (e) => {
      self.setOffset(true);
    });
  }

  // Set cookie if open/closed the account menu overlay
  menuOverlay() {
    const btnAccountOverlay = document.getElementById('account-overlay');
    if (!btnAccountOverlay) {
      return;
    }
    let cookieName = 'show_inretail_account_menu';

    document.querySelectorAll('.js-account-aside__item').forEach(element => {

      element.addEventListener('click', function (e) {
        e.preventDefault();

        // Open
        let menuCookie = getCookie(cookieName);

        let newValue = element.getAttribute('data-cookie-value') || 0;
        if (1 === parseFloat(menuCookie)) {
          deleteCookie(cookieName)
          // Closed
          newValue = 0;
        }

        setCookie(cookieName, newValue, 7);

        if (this.getAttribute('href') === window.location.href) {
          btnAccountOverlay.querySelector('button').click();
          return false;
        } else if (null !== this.getAttribute('href')) {
          window.location.assign(this.getAttribute('href'));
        }
      });
    });
  }
}

